import { useCallback, useState } from 'react'
import { useAuthStore } from '@/common/zustand/store/auth.store'
import { getTemplateDdjjMedico } from '@/common/utils/services/usuarios.service'
import { MODAL_CARGA_DDJJ } from '../constants/modal-carga-ddjj.js'

// Dispara la descarga del Blob con el nombre pedido por el criterio 3.
const guardarArchivo = (blob, nombre) => {
  const url = globalThis.URL.createObjectURL(blob)
  const link = globalThis.document.createElement('a')
  link.href = url
  link.download = nombre
  globalThis.document.body.appendChild(link)
  link.click()
  link.remove()
  globalThis.URL.revokeObjectURL(url)
}

// PBI 81147: descarga del template de la DDJJ precompletado (criterio 3).
// D8: `contrato` es opcional; sin prop se usa el contrato activo (apertura desde el banner).
export function useDescargaTemplateDdjj({
  contrato: contratoProp,
  nombreArchivo = MODAL_CARGA_DDJJ.template.archivo,
  mensajeError = MODAL_CARGA_DDJJ.errorDescarga,
} = {}) {
  const contratoActivo = useAuthStore((state) => state.contrato)
  const contrato = contratoProp ?? contratoActivo
  const [descargando, setDescargando] = useState(false)
  const [error, setError] = useState(null)

  const descargar = useCallback(async () => {
    setError(null)
    setDescargando(true)
    const res = await getTemplateDdjjMedico({ contrato: Number(contrato) })
    setDescargando(false)

    if (res.code === 200 && res.data) {
      guardarArchivo(res.data, nombreArchivo)
      return
    }
    setError(mensajeError)
  }, [contrato, nombreArchivo, mensajeError])

  const limpiarError = useCallback(() => setError(null), [])

  return { descargar, descargando, error, limpiarError }
}
